import React from 'react';
import { Space, Tag, Typography } from 'antd';
import { F } from '@/utils/intl';
import PrettyDate from '@/components/PrettyDate';
import { MessageMediumRenderer, MessageRendererProps } from '@/components/Communication/types';
import { WhatsAppOutlined } from '@ant-design/icons';
import styles from '@/components/Communication/renderers/WhatsApp/WhatsApp.less';

const { Text } = Typography;

const WhatsAppSummary: React.FC<MessageRendererProps> = ({ message }) => (
  <div className={styles.whatsAppSummaryContainer}>
    <WhatsAppOutlined className={styles.whatsAppIcon} />
    <Text ellipsis className={styles.whatsAppSummaryContent}>
      {message.content}
    </Text>
  </div>
);

const WhatsAppExtensive: React.FC<MessageRendererProps> = ({ message }) => (
  <div className={styles.whatsAppExtensiveContainer}>
    <div className={styles.whatsAppExtensiveHeader}>
      <Text strong>
        <WhatsAppOutlined className={styles.whatsAppIcon} /> <F id="communication.medium.whatsapp" defaultMessage="WhatsApp" />
      </Text>
      <Text type="secondary" className={styles.whatsAppExtensiveTimestamp}>
        <PrettyDate date={message.timestamp} />
      </Text>
    </div>
    <Text ellipsis className={styles.whatsAppExtensiveContent}>{message.content}</Text>
    <div className={styles.whatsAppStatusContainer}>
      <Tag color="green" className={styles.whatsAppStatusTag}>{message.status}</Tag>
    </div>
  </div>
);

const WhatsAppPreview: React.FC<MessageRendererProps> = ({ message }) => (
  <div className={styles.previewContainer}>
    <Space direction="vertical" className={styles.whatsAppPreviewSpace} size="small">
      <Tag color="green">
        <WhatsAppOutlined /> <F id="communication.medium.whatsapp" defaultMessage="WhatsApp" />
      </Tag>
      <Text strong className={styles.whatsAppPreviewSender}>
        <F id="communication.attribute.from" defaultMessage="From:" /> {message.sender}
      </Text>
      <div className={styles.bubble}>
        <Text className={styles.whatsAppBubbleText}>{message.content}</Text>
      </div>
      <Text type="secondary" className={styles.whatsAppPreviewTimestamp}>
        <PrettyDate date={message.timestamp} />
      </Text>
    </Space>
  </div>
);

const WhatsAppRenderers: MessageMediumRenderer = {
  Summary: WhatsAppSummary,
  Extensive: WhatsAppExtensive,
  Preview: WhatsAppPreview,
};

export default WhatsAppRenderers;
